
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { DocumentData } from '@firebase/firestore-types';
import { CollectionName, PublicAccessDecisions } from '@livv/models';
import { hasReadAccess, ReadPrivileges } from '@livv/models/accessRules';
import { GetServerSideProps, GetServerSidePropsContext } from 'next';
import DecisionPage, { DecisionPageProps } from '@screens/Decision/Show';
import withRestrictions from '@utils/hoc/withRestrictions';
import { getDecisionProps, getDecisionPublicAccess, getDeletedDecision, } from '@utils/serverSide/decision';
import getBasicServerSideProps, { BasicServerSideProps, } from '@utils/serverSide/getBasicServerSideProps';
interface ServerSideProps extends BasicServerSideProps, DecisionPageProps {
    hasReadAccess: boolean;
}
const getServerSideProps: GetServerSideProps<ServerSideProps> = async (ctx: GetServerSidePropsContext) => {
    const [deletedDecision, basicProps, fullDecisionPageProps, publicAccess] = await Promise.all([
        getDeletedDecision(ctx),
        getBasicServerSideProps(ctx),
        getDecisionProps(ctx),
        getDecisionPublicAccess(),
    ]);
    if (deletedDecision) {
        // Return status code 410 if decision is deleted
        const { res } = ctx;
        res.statusCode = 410;
        return {
            props: {},
        };
    }
    if (!fullDecisionPageProps || !publicAccess) {
        // Redirect to 404 page if decision page is not found or not accessible by free users
        return {
            notFound: true,
        };
    }
    const { analysisId, associatedDocuments, decision, decisionId, fullText } = fullDecisionPageProps;
    if (!decision) {
        // Redirect to 404 page if decision is not found
        return {
            notFound: true,
        };
    }
    if ('redirect' in basicProps) {
        return { redirect: basicProps.redirect };
    }
    const { props: { auth, userPrivileges }, } = basicProps;
    const readPrivileges: ReadPrivileges = {
        emailVerified: auth?.emailVerified || userPrivileges?.skipEmailVerification,
        isPaidCustomer: userPrivileges?.isPaidCustomer,
        role: userPrivileges?.role,
        trialEndDate: userPrivileges?.trialEndDate,
    };
    const readAccess = Boolean(fullDecisionPageProps?.decision && publicAccess) &&
        (await hasReadAccess(CollectionName.DECISIONS, fullDecisionPageProps?.decision as DocumentData, readPrivileges, () => Promise.resolve(publicAccess as PublicAccessDecisions)));
    const decisionPageProps: DecisionPageProps = {
        analysisId,
        associatedDocuments: undefined,
        decision: undefined,
        decisionId,
        fullText: undefined,
    };
    if (readAccess) {
        decisionPageProps.associatedDocuments = associatedDocuments;
        decisionPageProps.decision = decision;
        decisionPageProps.fullText = fullText;
    }
    const props: ServerSideProps = {
        ...basicProps.props,
        ...decisionPageProps,
        hasReadAccess: readAccess,
    };
    return {
        // To avoid SerializableError, wrap props into `JSON.parse(JSON.stringify())`
        // Ex: https://stackoverflow.com/questions/66817759/next-js-error-serializing-res-returned-from-getserversideprops
        props: JSON.parse(JSON.stringify(props)),
    };
};
export default withRestrictions(DecisionPage);

    async function __Next_Translate__getServerSideProps__1a06c87ef3a__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/decisions/[id]',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1a06c87ef3a__ as getServerSideProps }
  